import React from 'react'

import { AlertNotice, AlertNoticeProps } from '@ui/components/AlertNotice'

import { usePageNotice } from '@shared/components/PageNotice/PageNoticeContext'

export interface NoticeProps extends Omit<AlertNoticeProps, 'onClose'> {
  canClose?: boolean
  dismissDuration?: number
  paths?: string[]
  dismissType?: 'temporary' | 'session' | 'permanent'
}

export const Notice: React.FC<NoticeProps> = (note) => {
  const { canClose, ...restProps } = note
  const { dismissNotice } = usePageNotice()

  const handleClose = () => {
    dismissNotice(note.id, note.dismissType || 'temporary', note.dismissDuration || 14)
  }

  return <AlertNotice {...restProps} onClose={canClose ? handleClose : undefined} />
}
